import { render, staticRenderFns } from "./smallCard.vue?vue&type=template&id=4543633a&scoped=true&"
import script from "./smallCard.vue?vue&type=script&lang=js&"
export * from "./smallCard.vue?vue&type=script&lang=js&"
import style0 from "./smallCard.vue?vue&type=style&index=0&id=4543633a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4543633a",
  null
  
)

export default component.exports